<template>
  <div class="banner img-fluid" ref="banner" :class="{english:lang=='EN'}">
    <div class="hidden-xs">
      <!-- 英文版 -->
      <div class="swiper-container swiper-container-ds">
        <div class="swiper-wrapper">
          <!--          <div class="swiper-slide" ref="slide3">-->
          <!--            <video class="video-banner"-->
          <!--                   playsinline="true"-->
          <!--                   webkit-playsinline="true"-->
          <!--                   x-webkit-airplay="allow"-->
          <!--                   airplay="allow"-->
          <!--                   x5-video-player-type="h5"-->
          <!--                   x5-video-player-fullscreen="true"-->
          <!--                   x5-video-orientation="portrait"-->
          <!--                   loop autoplay muted ref="video"-->
          <!--                   poster="../../../assets/img/mainpage/banner03.png"-->
          <!--                   style="object-fit: cover;width: 100%;height:100%">-->
          <!--              <source src="../../../assets/video/home_bannerEn.mp4" type="video/mp4">-->
          <!--            </video>-->
          <!--          </div>-->
          <!--          <div class="swiper-slide">-->
          <!--            <img class="img-fluid banner-img" src="../../../assets/img/mainpage/banner02.jpg" @load="loadedImg">-->
          <!--            <div class="banner-operate">-->
          <!--              <div class="content wow animated fadeInUp">-->
          <!--                <img class="img-fluid" src="../../../assets/img/mainpage/MIND.png">-->
          <!--                <p>{{ $t('home.banner.banner1Info') }}</p>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
          <!--        </div>-->
          <div class="swiper-slide">
            <img class="img-fluid banner-img" src="../../../assets/img/mainpage/banner01.jpg" @load="loadedImg">
            <div class="banner-operate">
              <div class="content wow animated fadeInUp">
                <!--                <img class="img-fluid" src="../../../assets/img/LOGO_with_name.png">-->
                <!--                <p>{{ $t('home.banner.banner1Info') }}</p>-->
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <img class="img-fluid banner-img" src="../../../assets/img/mainpage/banner21.jpg" @load="loadedImg">
            <div class="banner-operate">
              <div class="content wow animated fadeInUp">
                <!--                <img class="img-fluid" src="../../../assets/img/LOGO_with_name.png">-->
                <!--                <p>{{ $t('home.banner.banner1Info') }}</p>-->
              </div>
            </div>
          </div>
          <!--          <div class="swiper-slide">-->
          <!--            <img class="img-fluid banner-img" src="../../../assets/img/mainpage/banner31.jpeg" @load="loadedImg">-->
          <!--            <div class="banner-operate">-->
          <!--              <div class="content wow animated fadeInUp">-->
          <!--&lt;!&ndash;                <img class="img-fluid" src="../../../assets/img/LOGO_with_name.png">&ndash;&gt;-->
          <!--&lt;!&ndash;                <p>{{ $t('home.banner.banner1Info') }}</p>&ndash;&gt;-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="swiper-slide">
            <img class="img-fluid banner-img" src="../../../assets/img/mainpage/banner31.jpg" @load="loadedImg">
            <div class="banner-operate">
              <div class="content wow animated fadeInUp">
                <!--                <img class="img-fluid" src="../../../assets/img/LOGO_with_name.png">-->
                <!--                <p>{{ $t('home.banner.banner1Info') }}</p>-->
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
    <div class="visible-xs">
      <div class="swiper-container swiper-container-xs" style="margin-top: 3.5rem;">
        <div class="swiper-wrapper">
<!--          <div class="swiper-slide" ref="slide3Xs" id="slide3Xs">-->
<!--            &lt;!&ndash; <img  class="img-fluid banner-img" src="../../../assets/img/mainpage/banner03.png"> &ndash;&gt;-->
<!--            <video class="video-banner-xs"-->
<!--                   id="video2" ref="video2"-->
<!--                   poster="../../../assets/img/mainpage/banner03.png"-->
<!--                   playsinline="true"-->
<!--                   webkit-playsinline="true"-->
<!--                   x-webkit-airplay="allow"-->
<!--                   airplay="allow"-->
<!--                   x5-video-player-type="h5"-->
<!--                   x5-video-player-fullscreen="true"-->
<!--                   x5-video-orientation="portrait"-->
<!--                   loop autoplay muted-->
<!--                   style="object-fit: cover;width: 100%;height:100%">-->
<!--              <source src="../../../assets/video/home_bannerEn.mp4" type="video/mp4">-->
<!--            </video>-->
<!--          </div>-->
<!--          <div class="swiper-slide">-->
<!--            <img class="img-fluid banner-img" src="../../../assets/img/mainpage/banner02.jpg" @load="loadedXsImg">-->
<!--            <div class="banner-operate">-->
<!--              <div class="content wow animated fadeInUp">-->
<!--                <img class="img-fluid banner1" src="../../../assets/img/mainpage/MIND.png">-->
<!--                <p>{{ $t('home.banner.banner1Info') }}</p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
          <div class="swiper-slide">
            <img class="img-fluid banner-img" src="../../../assets/img/mainpage/banner01.jpg" @load="loadedImg">
            <div class="banner-operate">
              <div class="content wow animated fadeInUp">
                <!--                <img class="img-fluid" src="../../../assets/img/LOGO_with_name.png">-->
                <!--                <p>{{ $t('home.banner.banner1Info') }}</p>-->
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <img class="img-fluid banner-img" src="../../../assets/img/mainpage/banner21.jpg" @load="loadedImg">
            <div class="banner-operate">
              <div class="content wow animated fadeInUp">
                <!--                <img class="img-fluid" src="../../../assets/img/LOGO_with_name.png">-->
                <!--                <p>{{ $t('home.banner.banner1Info') }}</p>-->
              </div>
            </div>
          </div>
          <!--          <div class="swiper-slide">-->
          <!--            <img class="img-fluid banner-img" src="../../../assets/img/mainpage/banner31.jpeg" @load="loadedImg">-->
          <!--            <div class="banner-operate">-->
          <!--              <div class="content wow animated fadeInUp">-->
          <!--&lt;!&ndash;                <img class="img-fluid" src="../../../assets/img/LOGO_with_name.png">&ndash;&gt;-->
          <!--&lt;!&ndash;                <p>{{ $t('home.banner.banner1Info') }}</p>&ndash;&gt;-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="swiper-slide">
            <img class="img-fluid banner-img" src="../../../assets/img/mainpage/banner31.jpg" @load="loadedImg">
            <div class="banner-operate">
              <div class="content wow animated fadeInUp">
                <!--                <img class="img-fluid" src="../../../assets/img/LOGO_with_name.png">-->
                <!--                <p>{{ $t('home.banner.banner1Info') }}</p>-->
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
  </div>

</template>

<script>
import {mapGetters} from 'vuex'
// import Swiper from '../../../../node_modules/swiper/js/swiper.min.js'
// import Swiper from '@/assets/js/swiper.min.js'
import Swiper from '../../../../node_modules/swiper/js/swiper.min.js'

export default {
  name: 'MainBanner',
  data () {
    return {
      curIndex: 0,
      mySwiper: null,
      myXSwiper: null,
      mySwiperEN: null,
      myXSwiperEN: null,
    }
  },
  components: {},
  methods: {
    changeBanner (index) {
      this.curIndex = index
      this.mySwiper.slideToLoop(index, 1000, false)
    },
    changeXsBanner (index) {
      this.curIndex = index
      this.myXSwiper.slideToLoop(index, 1000, false)
    },
    loadedImg (e) {
      let img = new Image()
      img.src = require('../../../assets/img/mainpage/banner03.png')
      img.onload = () => {
        $('.video-banner').height(this.$refs.banner.offsetWidth * img.height / img.width)
        this.$refs.slide3.style.height = this.$refs.banner.offsetWidth * img.height / img.width + 'px'
      }
    },
    loadedXsImg (e) {
      let img = new Image()
      img.src = require('../../../assets/img/mainpage/banner03.png')
      img.onload = () => {
        $('.video-banner-xs').height(this.$refs.banner.offsetWidth * img.height / img.width)
        this.$refs.slide3Xs.style.height = this.$refs.banner.offsetWidth * img.height / img.width + 'px'
      }
    },
    init () {
      const _this = this
      this.mySwiperEN = new Swiper('.swiper-container-ds', {
        loop: true,
        // loopAdditionalSlides: -1,
        speed: 1000,
        effect: 'slide',
        updateOnImagesReady: true,
        // disableOnInteraction: false, //手动滑动之后不打断播放
        observer: true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,//修改swiper的父元素时，自动初始化swiper
        autoplay: {
          // 用户操作swiper之后，是否禁止autoplay，默认为true
          disableOnInteraction: false,
          delay: 5000,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        on: {
          init: function () {
            setTimeout(() => {
              $('.video-banner').height($('.banner-img').height())
            }, 10)
          },
          slideChange: function () {
            _this.curIndex = this.realIndex
          },

          resize: function () {
            $('.video-banner').height(0)
            setTimeout(() => {
              $('.video-banner').height($('.banner-img').height())
            }, 0)
          }
        },
      })
      this.myXSwiper = new Swiper('.swiper-container-xs', {
        loop: false,
        // loopAdditionalSlides: -1,
        speed: 1000,
        effect: 'slide',
        updateOnImagesReady: true,
        // disableOnInteraction: false, //手动滑动之后不打断播放
        observer: true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,//修改swiper的父元素时，自动初始化swiper
        autoplay: {
          // 用户操作swiper之后，是否禁止autoplay，默认为true
          disableOnInteraction: false,
          delay: 5000,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        on: {
          init: function () {
            setTimeout(() => {
              $('.video-banner-xs').height($('#slide3Xs').height())
            }, 10)
          },
          slideChange: function () {
            _this.curIndex = this.realIndex
          },
          resize: function () {
            this.update()
          },
        },
      })
    }
  },
  mounted () {
    window.onresize = () => {
      $('.video-banner').height($('.banner-img').height())
      if (this.$store.state.isMobile) {
        this.$refs.slide3Xs.style.height = $('.banner-img').height() + 'px'
      }
    }
    window.eventBus.$on('videoHide', (data) => {
      if (data) {
        $('#video2').show()
        // var video=document.getElementById('video2');
        // video.play();
      } else {
        $('#video2').hide()
      }
    })

    // 视频点击放大播放后，重新初始化
    // window.eventBus.$on('initHomeBanner',()=>{
    //   this.$nextTick(()=>{
    //       this.myXSwiper=null;
    //       this.mySwiper=null;
    //       this.init();
    //       $('.swiper-container-xs').css({"marginTop":"3.5rem"});
    //   })
    // })
    this.$nextTick(() => {
      this.init()
    })
  },
  computed: {
    ...mapGetters([
      'isMobile',
      'lang'
    ])
  },
  beforeDestroy () {
    this.mySwiper && this.mySwiper.destroy()
    this.myXSwiper && this.myXSwiper.destroy()
  },
}
</script>

<style lang="scss" scoped>
.banner {
  position: relative;
  width: 100%;
  height: auto;
  max-height: 257rem;

  .banner-operate {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: auto;
    position: absolute;
    z-index: 10;
    width: 100%;
    height: 100%;
    top: 0;

    .content {
      width: 100%;
      max-width: 75rem;

      .img-fluid {
        width: 35.25rem;
        height: auto;
        max-width: 30rem;
      }

      p {
        margin-top: 1.5%;
        font-size: 2.4rem;
        font-family: Arial, Source Han Sans CN;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        letter-spacing: 0.45rem;
      }
    }

  }

  .button-ul {
    /*position: absolute;*/
    display: flex;
    width: 100%;
    max-width: 75rem;
    bottom: 10%;

    .button-li {
      background: url("../../../assets/img/mainpage/hexagon_btn.png") no-repeat;
      width: 1.125rem;
      height: 1.5rem;
      background-size: 100%;
      cursor: pointer;
      margin-right: 2.25rem;
    }

    .active {
      background: url("../../../assets/img/mainpage/hexagon_btn_active.png") no-repeat;
      width: 1.125rem;
      height: 1.5rem;
      background-size: 100%;
    }
  }

  .banner-inro {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    background: rgba(12, 15, 20, 0.6);

    .caption {
      font-size: 2.87rem;
      font-family: Arial, Source Han Sans CN;
      font-weight: 300;
      color: rgba(255, 255, 255, 1);
      line-height: 5.83rem;
      letter-spacing: 0.6rem;
      margin-top: -2.25rem;

      span {
        font-size: 1.8rem;
        width: 2.5rem;
        text-align: center;
        display: inline-block;
      }
    }

    .title {
      font-size: 1.125rem;
      font-family: Arial, Source Han Sans CN;
      font-weight: 300;
      color: rgba(255, 255, 255, 1);
      letter-spacing: 0.19rem;
    }

    .view-video {
      width: 10.75rem;
      height: 3.19rem;
      display: flex;
      justify-content: center;
      align-items: center;
      background: url("../../../assets/img/mainpage/button01.png") no-repeat;
      background-size: contain;
      margin-top: 2.9rem;
      cursor: pointer;
      letter-spacing: 0.15rem;

      span {
        font-size: 1.05rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
      }

      img {
        width: 1.05rem;
        height: 1.05rem;
        margin-left: 0.375rem;
      }
    }

    .view-video:hover {
      background: url("../../../assets/img/mainpage/button01_active.png") no-repeat;
      background-size: contain;
    }
  }

  .visible-xs {
    .banner-img {
      /*height: 250px;*/
      /*width: auto;*/
      width: 100%;
      height: auto;
    }

    .banner-operate {
      .content {
        max-width: 85%;

        img {
          width: 10rem;
        }

        p {
          font-size: 1rem;
        }
      }
    }

    .banner-inro {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 0;
      background: rgba(12, 15, 20, 0.6);

      .caption {
        font-size: 1.2rem;
        font-family: Arial, Source Han Sans CN;
        font-weight: 300;
        color: rgba(255, 255, 255, 1);
        line-height: 3rem;
        letter-spacing: 0.3rem;
        margin-top: -1rem;

        span {
          font-size: 1.2rem;
          width: 1.5rem;
        }
      }

      .title {
        font-size: 0.8rem;
        font-family: Arial, Source Han Sans CN;
        font-weight: 300;
        color: rgba(255, 255, 255, 1);
        letter-spacing: 0.19rem;
      }

      .view-video {
        width: 8.0625rem;
        height: 2.3925rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background: url("../../../assets/img/mainpage/button01.png") no-repeat;
        background-size: contain;
        margin-top: 0.5rem;
        cursor: pointer;
        letter-spacing: 0.15rem;

        span {
          font-size: 0.8rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
        }

        img {
          width: 0.68rem;
          height: 0.68rem;
          margin-left: 0.187rem;
        }
      }

      .view-video:hover {
        background: url("../../../assets/img/mainpage/button01_active.png") no-repeat;
        background-size: contain;
      }
    }
  }
}

.english {
  .banner-operate {
    .content {
      p {
        font-size: 2.1rem;
        letter-spacing: 0.1rem;
      }
    }
  }

  .hidden-xs {
    .caption {
      letter-spacing: 0 !important;
      text-align: center;

      span {
        display: none;
      }
    }

    .view-video {
      letter-spacing: 0.05rem;
    }
  }

  .visible-xs {
    .banner-operate {
      .content {
        p {
          white-space: pre-wrap;
        }
      }
    }

    .caption {
      font-size: 1rem !important;
      letter-spacing: 0 !important;
      text-align: center;

      span {
        display: none;
      }
    }

    .view-video {
      letter-spacing: 0.05rem !important;
    }
  }
}
</style>
<style lang="scss" scoped>
//产品轮播图按钮样式
/deep/ .swiper-container-ds.swiper-container-horizontal > .swiper-pagination-bullets,
.swiper-pagination-custom,
.swiper-pagination-fraction {
  bottom: 10%;
  left: 50%;
  max-width: 67.5rem;
  transform: translate(-50%, 0%);
  text-align: left;
}

/deep/ .swiper-container-ds.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
  background: url("../../../assets/img/mainpage/hexagon_btn.png") no-repeat;
  width: 1rem;
  height: 1rem;
  /*background-size: 100% 100%;*/
  background-size: cover;
  background-position: center center;
  cursor: pointer;
  margin-right: 2.25rem;
}

/deep/ .swiper-container-ds.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet.swiper-pagination-bullet-active {
  background: url("../../../assets/img/mainpage/hexagon_btn_active.png") no-repeat;
  width: 1rem;
  height: 1rem;
  /*background-size: 100% 100%;*/
  background-size: cover;
  background-position: center center;
}
</style>



// WEBPACK FOOTER //
// src/components/common/home/MainBannerEN.vue